import React from 'react'
import Footer from '../Footer'
import EducationCLRHS5 from '../EducationCLRHS5'

function CLRHS5() {
    window.scrollTo(0,0);
    return (
        <div>
            <EducationCLRHS5/>
            <Footer/>
        </div>
    )
}

export default CLRHS5
